import React from 'react';

const CarouselItem: React.FC = ({ children }) => {
  return <>{children}</>;
};

export default CarouselItem;
